const announcementsAdminRoutes = [
  {
    path: '/announcements',
    name: 'ManageAnnouncements',
    component: () => import('./admin/manage-announcements.vue'),
    meta: {
    },
  },
  {
    path: '/announcements/new/',
    name: 'ManageAnnouncements', // NewAnnouncement: Keeping one route name to manage permission as one
    component: () => import('./admin/announcement-form.vue'),
    meta: {
    },
  },
  {
    path: '/announcements/:id',
    name: 'ManageAnnouncements', // EditAnnouncement: Keeping one route name to manage permission as one
    component: () => import('./admin/announcement-form.vue'),
    meta: {
    },
  },
];

export default announcementsAdminRoutes;
